/* eslint-disable */
import api from '~/services/api';
// import events from '~/constants/events';

export default (context, inject) => {
  // get consent value from Cookies
  let { consent } = context.$cookies.get('cookie-preferences') || {};

  // get or set anonymous Id
  let { anonymousId } = context.$cookies.get('app') || {};

  // additional methods to track events in components
  const analyticsMethods = {
    async trackEvent(name, payload) {
      // console.log('BI LOG', name, payload);
      await api.logBi(context, {
        anonymousId,
        platform: 'central',
        consent,
        events: [
          {
            event: name,
            params: payload,
            timestamp: Date.now(),
          },
        ],
      });
    },
  };

  inject('analytics', analyticsMethods);
  context.$analytics = analyticsMethods;
};
